import client from './client';

export const register = async (email, password, displayName) => {
  const response = await client.post('/api/auth/register', {
    email,
    password,
    displayName,
  });
  return response.data;
};

export const login = async (email, password) => {
  const response = await client.post('/api/auth/login', {
    email,
    password,
  });
  return response.data;
};

export const logout = async () => {
  const response = await client.post('/api/auth/logout');
  return response.data;
};

export const getMe = async () => {
  const response = await client.get('/api/auth/me');
  return response.data;
};

export const updateProfile = async (updates) => {
  const response = await client.put('/api/auth/me', updates);
  return response.data;
};

export const changePassword = async (currentPassword, newPassword) => {
  const response = await client.post('/api/auth/change-password', {
    currentPassword,
    newPassword,
  });
  return response.data;
};

export const uploadAvatar = async (file) => {
  const formData = new FormData();
  formData.append('avatar', file);
  const response = await client.post('/api/auth/avatar', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

export const removeAvatar = async () => {
  const response = await client.delete('/api/auth/avatar');
  return response.data;
};
